import { useEffect } from "react";

export default function InviteRedirect() {
  useEffect(() => {
    window.location.href = "https://discord.com/oauth2/authorize?client_id=800177577310289990&scope=bot%20applications.commands&permissions=388301";
  }, []);

  return null;
}
